import { ApplicationConfig } from "@angular/core";
import { provideZoneChangeDetection } from "@angular/core";
import { provideRouter } from "@angular/router";
import { provideAnimationsAsync } from "@angular/platform-browser/animations/async";
import { provideHttpClient, withInterceptors } from "@angular/common/http";
import { provideStore } from "@ngrx/store";
import { provideEffects } from "@ngrx/effects";
import { providePrimeNG } from "primeng/config";

// 👇 Importa tu tema PrimeNG (puedes cambiarlo fácilmente)
import Aura from "@primeng/themes/aura";
// import Material from '@primeng/themes/material';
// import Lara from '@primeng/themes/lara';

// Personalizar el tema Aura con color primario #10B981DE
const customAura = {
  ...Aura,
  semantic: {
    ...Aura.semantic,
    primary: {
      ...Aura.semantic?.primary,
      50: "#ecfdf5",
      100: "#d1fae5",
      200: "#a7f3d0",
      300: "#6ee7b7",
      400: "#34d399",
      500: "#10B981DE", // Color principal
      600: "#059669",
      700: "#047857",
      800: "#065f46",
      900: "#064e3b",
      950: "#022c22",
    },
  },
};

import { routes } from "./app.routes";
import { authInterceptor } from "./guards/auth.interceptor";
import { es } from "primelocale/es.json";

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideAnimationsAsync(),
    providePrimeNG({
      translation: es,
      theme: {
        preset: customAura, // 👈 Tema personalizado con color gris oscuro
        options: {
          prefix: "arc", // prefijo CSS (opcional, para aislar estilos)
          darkModeSelector: ".my-app-dark", // selector para modo oscuro manual
          scope: "primeng", // identificador del tema (por si cambias dinámicamente)
        },
      },
    }),
    provideRouter(routes),
    provideStore(),
    provideEffects(),
    provideHttpClient(withInterceptors([authInterceptor])),
  ],
};
